'use strict';

goog.provide("Ntry.Unit");

goog.require("Ntry.STATIC");

Ntry.Unit = function(unit) {
    if (!unit)
        unit = {};
    this.direction = Number(unit.direction);
    this.action = Ntry.STATIC.STAND;
    this.step = 0;
}

Ntry.Unit.prototype.type =
    Ntry.STATIC.UNIT;
